/**
 * GxPill: the one chip. Variants: `status` (a tone, with a glyph or word, never colour alone), `tier` (OR-30.40: gold fill for the top two tiers, an outline for Solid,
 * a muted outline for Behind), `count` (a small number or "n of m", neutral). Everything else (the limit state chip, the forecast pill) keeps its own component and its own meaning.
 */
import type { ReactNode } from "react";
import "./system.css";

export type PillTone = "good" | "warn" | "crit" | "info" | "neutral" | "gold";
export type TierLevel = "top" | "solid" | "behind";

export type GxPillProps =
  | { readonly variant?: "status"; readonly tone: PillTone; readonly children: ReactNode; readonly testId?: string; readonly title?: string; readonly label?: string }
  | { readonly variant: "tier"; readonly level: TierLevel; readonly children: ReactNode; readonly testId?: string; readonly title?: string }
  | { readonly variant: "count"; readonly children: ReactNode; readonly testId?: string; readonly title?: string };

export function GxPill(props: GxPillProps) {
  const data = props.variant === "tier" ? { "data-level": props.level } : props.variant === "count" ? {} : { "data-tone": props.tone };
  // `label`: the pill shows a glyph and the words stay as its accessible name and tooltip (a verdict mark on a phone).
  const label = props.variant === undefined || props.variant === "status" ? props.label : undefined;
  const labelled = label === undefined ? {} : { role: "img", "aria-label": label, title: label };
  return <span className={`gx-pill gx-pill--${props.variant ?? "status"}${label === undefined ? "" : " gx-pill--glyph"} gx-num`} data-testid={props.testId} {...(props.title === undefined ? {} : { title: props.title })} {...labelled} {...data}>{props.children}</span>;
}
